export default __webpack_public_path__ + "images/upload.1b3c2506f6f5e46d7c3c71f18440a693.svg";